import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {isPlatformBrowser} from '@angular/common';
import {takeUntil} from 'rxjs/operators';
import * as moment from 'moment-timezone';
import {ServerSelectModalComponent} from '../modals/server-select/server-select-modal.component';
import {QueueSelectModalComponent} from '../modals/queue-select/queue-select-modal.component';
import {LpSelectModalComponent} from '../modals/lp-select/lp-select-modal.component';
import {RankSelectModalComponent} from '../modals/rank-select/rank-select-modal.component';
import {DivisionSelectModalComponent} from '../modals/division-select/division-select-modal.component';
import {DivisionsService} from '../../../../../shared/modules/core/services/divisions.service';
import {NgxEzModalService} from '../../../../../shared/modules/ngx-ez-modal/ngx-ez-modal.service';
import {Service} from './service';
import {ServiceParams} from './service-params';
import {Subject} from 'rxjs';
import {ServiceCustomization} from './service-customization';
import {PriceService} from '../../../../../shared/modules/core/services/price.service';
import {MasterySelectModalComponent} from '../modals/mastery-select/mastery-select-modal.component';
import {LolCharacterSelectComponent} from '../modals/lol-character-select/lol-character-select.component';
import {ValorantDivisionSelectComponent} from '../modals/valorant-division-select/valorant-division-select.component';
import {ValorantRankSelectComponent} from '../modals/valorant-rank-select/valorant-rank-select.component';
import {WildRiftRankSelectComponent} from '../modals/wild-rift-rank-select/wild-rift-rank-select.component';
import {WildRiftDivisionSelectComponent} from '../modals/wild-rift-division-select/wild-rift-division-select.component';
import {WildRiftLpSelectComponent} from '../modals/wild-rift-lp-select/wild-rift-lp-select.component';
import {ApexRankSelectComponent} from '../modals/apex-rank-select/apex-rank-select.component';
import {PlatformSelectModalComponent} from '../modals/platform-select/platform-select-modal.component';
import {services} from '../services';
import {ApexLpSelectModalComponent} from "../modals/apex-lp-select/apex-lp-select-modal.component";
import {ApexDivisionSelectComponent} from "../modals/apex-division-select/apex-division-select.component";
import {ApexBadgeSelectComponent} from "../modals/apex-badge-select/apex-badge-select.component";
import {OverwatchRankSelectModalComponent} from "../modals/overwatch-rank-select/overwatch-rank-select-modal.component";
import {TftRankSelectModalComponent} from '../modals/tft-rank-select/tft-rank-select-modal.component';
import {TftDivisionSelectModalComponent} from "../modals/tft-division-select/tft-division-select-modal.component";
import {AverageCompletionService} from "../../../../../shared/modules/core/services/average.completion.service";
import {Cs2RatingSelectComponent} from "../modals/cs2-rating-select/cs2-rating-select.component";
import {Cs2RankSelectComponent} from "../modals/cs2-rank-select/cs2-rank-select.component";
import {Cs2MapsSelectComponent} from "../modals/cs2-maps-select/cs2-maps-select.component";
import { ActivatedRoute } from '@angular/router';
import { GameCharacterSelectComponent } from '../modals/game-character-select/game-character-select.component';
import { placements } from '@popperjs/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-service-layout-v2',
  templateUrl: './service-layout-v2.component.html',
  styleUrls: ['./service-layout-v2.component.scss']
})
export class ServiceLayoutV2Component implements OnInit, OnDestroy, AfterViewInit {
  @Input() serviceParams: ServiceParams;
  @Input() serviceFaqs: { question: string; answer: string }[];
  @Input() currentServiceIcon: string;
  @Input() availableServices: { name: string; icon: string; url: string }[] = [];
  @Input() lang: string;

  @ViewChild('purchaseBox', {static: true}) purchaseBox: ElementRef;

  public service: Partial<Service> = {};
  public customization: ServiceCustomization = {
    primaryPosition: 'middle',
    secondaryPosition: 'bottom',
    keySet: 1,
    characters: []
  };
  public delay: string;
  public divisionService = DivisionsService;
  public mToGmLps;
  public tftMToGmLps;
  public valorantMToGmLps;

  public campaignByGame = {
    lol: 'season-start',
    valorant: 'season-start',
    apex: 'season-start',
    cs2: 'season-start',
    cod: 'default',
    siege: 'default',
    tft: 'season-start',
    'wild-rift': 'season-start',
    marvel: 'season-start'
  }
  public campaignCharacterByGame = {
    lol: 'default',
    valorant: 'default',
    apex: 'default',
    cs2: 'default',
    cod: 'default',
    siege: 'default',
    tft: 'default',
    'wild-rift': 'default',
    marvel: 'default'
  }

  topCampaignTextByGame = {
    lol: '2025 SEASON 1',
    valorant: '2025 ACT 2',
    tft: 'SET 14',
    'wild-rift': 'Season 17',
    cs2: 'Season 2',
    apex: 'Season 24',
    marvel: 'Season 2'
  }

  public campaignTimerByGame = {
    lol:false,
    valorant:false,
  }
  public campaignTimerPositionByGame = {
    lol:{
      top:0,
      left:0
    },
    valorant:{
      top:0,
      left:0
    }
  }
  public countdownDayDigit1 = '0';
  public countdownDayDigit2 = '0';
  public countdownHourDigit1 = '0';
  public countdownHourDigit2 = '0';
  public countdownMinuteDigit1 = '0';
  public countdownMinuteDigit2 = '0';
  public seasonEndCountdown: any;

  public cdnUrl = 'https://cdn.ggboost.com/images';

  checkDecorated(val) {
    console.log(val);
  }

  public decoredServices = {
    lol: {},
    tft: {},
    cs2: {},
    apex: {},
    valorant: {},
    'wild-rift': { placements: true },
    marvel: {}
  };

  public gameColors = {
    apex: '#F54351',
    cs2: '#fc9c1a',
    cod: '#F54351',
    siege: '#F54351',
    valorant: '#F54351',
    lol: '#f5ab4e',
    tft: '#f5ab4e',
    'wild-rift': '#2ec9ff',
    // 'wild-rift': '#43f5ab',
    marvel: '#f5ab4e'
  };

  private isBrowser = false;
  private componentDestroyed = new Subject();
  private scrollingInstance;
  private prefix = '';
  public game = '';

  // lang: string = 'en';

  hideImage: boolean = false;
  @HostListener('window:scroll', []) onWindowScroll(): void {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const threshold = 50; // Change this value based on when you want to hide the image

    if (scrollY > threshold) {
      this.hideImage = true;
    }
  }

  @HostListener('window:resize') onResize() {
    if (this.scrollingInstance) {
      this.scrollingInstance.updateSticky();
    }
  }

  constructor(
    private modalService: NgxEzModalService,
    private cookie: CookieService,
    @Inject(PLATFORM_ID) platformId,
    private resolver: ComponentFactoryResolver,
    private priceService: PriceService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {
    if (isPlatformBrowser(platformId)) {
      this.isBrowser = true;
    }

    if (!this.lang) {
      this.route.url.subscribe(url => {
        if (url[0].path === 'lol-boost' || url[0].path === 'marvel-rivals-boost') {
          this.lang = 'en';
        } else {
          this.lang = url[0].path;
        }
      });
    }

  }

  async ngOnInit() {
    this.setService();
    this.setTimers();
    this.setServer();
    this.fixValues();
    this.calculateServiceTime();
    await this.fetchPrices();
  }

  ngAfterViewInit() {
    if (!this.service || !this.service.server) {
      setTimeout(() => {
        this.showServerSelect();
      }, 1000);
    }
  }

  setServer() {
    let region = this.mapTimezoneToRegion();
    if (this.cookie.check('gg-' + this.service.game + '-server')) {
      return;
    }

    if (region !== 'other') {
      if (this.service.game === 'lol' || this.service.game === 'tft' || this.service.game === 'wild-rift') {
        if (region === 'europe') {
          this.service.server = 'euw';
        } else if (region === 'americas') {
          this.service.server = 'na';
        } else if (region === 'oceania') {
          this.service.server = 'oce';
        } else if (region === 'middle-east') {
          this.service.server = 'me';
        }
      } else if (this.service.game === 'valorant') {
        if (region === 'europe') {
          this.service.server = 'eu';
        } else if (region === 'americas') {
          this.service.server = 'na';
        } else if (region === 'oceania') {
          this.service.server = 'oce';
        }
      } else if (this.service.game === 'apex' || this.service.game === 'cs2') {
        if (region === 'europe') {
          this.service.server = 'europe';
        } else if (region === 'americas') {
          this.service.server = 'americas';
        } else if (region === 'oceania') {
          this.service.server = 'oceania';
        }
      } else if (this.service.game === 'marvel') {
        if (region === 'europe') {
          this.service.server = 'eu'
        } else if (region === 'americas') {
          this.service.server = 'na';
        }
      }
      this.cookie.set('gg-' + this.service.game + '-server', this.service.server, 3650, '/');
    }
  }

  mapTimezoneToRegion = (): string => {
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toLowerCase();
    // These are representative substrings for each region.
    const americasSubstrings = ["america", "honolulu"];
    const oceaniaSubstrings = ["pacific", "australia"];
    const europeSubstrings = ["europe"];
    const middleEastSubstrings = ["asia/jerusalem", "asia/amman", "asia/beirut", "asia/dubai", "asia/gaza", "asia/hebron", "asia/kuwait", "asia/riyadh", "asia/tehran", "asia/baghdad", "asia/manama", "asia/doha"];
    // ... (add other major Russian timezones in Asia if needed)

    if (americasSubstrings.some(sub => timezone.includes(sub))) {
      return 'americas';
    } else if (oceaniaSubstrings.some(sub => timezone.includes(sub))) {
      return 'oceania';
    } else if (europeSubstrings.some(sub => timezone.includes(sub))) {
      return 'europe';
    } else if (middleEastSubstrings.some(sub => timezone.includes(sub))) {
      return 'middle-east';
    } else {
      return 'other'; // for other regions or if you want a default
    }
  }

  onSoloOnlyChange(status: boolean) {
    this.service = {
      ...this.service,
      isSoloOnly: status
    }
  }

  onStreamingChange(status: boolean) {
    this.service = {
      ...this.service,
      streaming: status
    }
  }

  onVoiceChange(status: boolean) {
    this.service = {
      ...this.service,
      voice: status
    }
  }

  public onTypeChange(type: string) {
    this.service = {
      ...this.service,
      type: type
    };

    this.fixValues();
    this.calculateServiceTime();
  }


  public onExpressChange(express: string) {
    let isExpress = false;
    if (express === '1') {
      isExpress = true;
    }

    this.service = {
      ...this.service,
      isExpress: isExpress
    };
    this.fixValues();
    this.calculateServiceTime();
  }

  private updateCountdown() {
    const now = new Date();
    const targetDate = this.getSeasonEndTimeByServer(this.game, this.service.server);
    const timeDifference = targetDate.getTime() - now.getTime();

    if (timeDifference > 0) {
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

      this.updateDigits(days, hours, minutes);
      this.cdr.detectChanges();
    } else {
      clearInterval(this.seasonEndCountdown);
      this.setAllDigitsToZero();
      this.cdr.detectChanges();
    }
  }

  getSeasonEndTimeByServer(game, server) {
    let date;
    if(game === 'lol') {
      if (server === 'na') {
        date = moment.tz('2024-01-09 23:59:59', 'America/Los_Angeles');
      } else if (server === 'oce') {
        date = moment.tz('2024-01-09 23:59:59', 'Australia/Sydney');
      } else if (server === 'euw') {
        date = moment.tz('2024-01-09 23:59:59', 'GMT');
      } else if (server === 'eune') {
        date = moment.tz('2024-01-09 23:59:59', 'Europe/Berlin');
      }
    } else if(game === 'valorant') {
      if (server === 'na') {
        date = moment.tz('2024-01-09 23:59:59', 'America/Los_Angeles');
      } else if (server === 'oce') {
        date = moment.tz('2024-01-09 23:59:59', 'Australia/Sydney');
      } else if (server === 'eu') {
        date = moment.tz('2024-01-09 23:59:59', 'GMT');
      }
    }

    return date.toDate();
  }

  private updateDigits(days: number, hours: number, minutes: number) {
    const dayString = days.toString().padStart(2, '0');
    const hourString = hours.toString().padStart(2, '0');
    const minuteString = minutes.toString().padStart(2, '0');

    this.countdownDayDigit1 = dayString.charAt(0);
    this.countdownDayDigit2 = dayString.charAt(1);
    this.countdownHourDigit1 = hourString.charAt(0);
    this.countdownHourDigit2 = hourString.charAt(1);
    this.countdownMinuteDigit1 = minuteString.charAt(0);
    this.countdownMinuteDigit2 = minuteString.charAt(1);

  }

  private setAllDigitsToZero() {
    this.countdownDayDigit1 = '0';
    this.countdownDayDigit2 = '0';
    this.countdownHourDigit1 = '0';
    this.countdownHourDigit2 = '0';
    this.countdownMinuteDigit1 = '0';
    this.countdownMinuteDigit2 = '0';
  }

  // public updatePosition(event) {
  //   const positionsProperty = event.position === 'primary' ? 'primaryPosition' : 'secondaryPosition';
  //   // if (positionsProperty === 'primaryPosition' && this.customization.secondaryPosition.position === event.role) {
  //   //   this.customization.secondaryPosition.position = this.customization.primaryPosition.position;
  //   // }
  //   // if (positionsProperty === 'secondaryPosition' && this.customization.primaryPosition.position === event.role) {
  //   //   this.customization.primaryPosition.position = this.customization.secondaryPosition.position;
  //   // }

  //   // this.customization = {
  //   //   ...this.customization,
  //   //   [positionsProperty]: {
  //   //     ...this.customization[positionsProperty],
  //   //     position: event.role,
  //   //   }
  //   // };
  // }

  // public updateChampions(event) {
  //   this.customization = {
  //     ...this.customization,
  //     [event.position === 'primary' ? 'primaryPosition' : 'secondaryPosition']: {
  //       // ...this.customization[event.position === 'primary' ? 'primaryPosition' : 'secondaryPosition'],
  //       champions: event.champions,
  //     }
  //   };
  // }

  // public updateKeySet(keySet) {
  //   this.customization = {
  //     ...this.customization,
  //     keySet
  //   };
  // }

  public showServerSelect() {
    const serverSelector = (
      this.modalService.open(
        'serverSelect',
        ServerSelectModalComponent,
        false,
        {width: '700px', closeOnOutsideClick: false},
        this.resolver
      )
    ) as ServerSelectModalComponent;
    serverSelector.game = this.service.game;
    serverSelector.lang = this.lang;
    serverSelector.selected
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(server => {
        this.service = {
          ...this.service,
          server
        };

        /*if (this.service.service === 'divisions' && this.service.current === 24) {
          this.service = {
            ...this.service,
            lp: 0
          };
        }*/

        this.cookie.set('gg-' + this.game + '-server', server, 3650, '/');

        if (this.serviceParams.game === 'valorant' &&
          (this.service.current === DivisionsService.getValueByRank('Immortal I', 'valorant') ||
            this.service.current === DivisionsService.getValueByRank('Immortal II', 'valorant') ||
            this.service.current === DivisionsService.getValueByRank('Immortal III', 'valorant'))) {
          this.service.lp = this.findMinLp(this.service.current, this.serviceParams.game);
        }
        if ((this.serviceParams.game === 'lol' || this.serviceParams.game === 'tft') &&
          this.service.current === DivisionsService.getValueByRank('Master', this.serviceParams.game)) {
          this.service.lp = this.findMinLp(this.service.current, this.serviceParams.game);
        }
      });
  }

  public showQueueSelect() {
    const queueSelector = (
      this.modalService.open(
        'queueSelect',
        QueueSelectModalComponent,
        false,
        {width: '600px'},
        this.resolver
      )
    ) as QueueSelectModalComponent;

    queueSelector.game = this.game;
    queueSelector.lang = this.lang;

    queueSelector.selected
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(queue => {
        this.service = {
          ...this.service,
          queue
        };
        this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-queue', queue, 3650, '/');
        if (queue === 'competitive') {
          this.service.champion = 'Dust2';
          this.showMapSelect();
        }

        // if (this.service.game === 'tft' && this.service.service === 'placements' && queue === 'doubleup') {
        //   this.service
        // }
      });
  }

  public showPlatformSelect() {
    const platformSelector = (
      this.modalService.open(
        'queueSelect',
        PlatformSelectModalComponent,
        false,
        {width: '300px'},
        this.resolver
      )
    ) as QueueSelectModalComponent;
    platformSelector.lang = this.lang;
    platformSelector.selected
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(platform => {
        this.service = {
          ...this.service,
          platform
        };
        if (platform !== 'pc') {
          this.onStreamingChange(false);
        }
        this.cookie.set('gg-' + this.prefix + 'platform', platform, 3650, '/');
      });
  }

  public async showLpSelect() {
    let component;

    if (this.serviceParams.game === 'wild-rift') {
      component = WildRiftLpSelectComponent;
    } else if (this.serviceParams.game === 'apex') {
      component = ApexLpSelectModalComponent;
    } else {
      component = LpSelectModalComponent;
    }

    const lpSelector = (this.modalService.open('lpSelect', component, false, {}, this.resolver)) as any;
    lpSelector.lang = this.lang;
    lpSelector.game = this.service.game;

    if(this.serviceParams.game === 'apex'){
      lpSelector.rankName = DivisionsService.getDivisionNameByValue(this.service.current,'apex').toLowerCase();
    }

    if (this.serviceParams.game === 'wild-rift') {
      lpSelector.currentRank = this.service.current;
    } else {
      lpSelector.maxMatches = 3;
      lpSelector.disablePromos = true;
      lpSelector.game = this.service.game;

      if (this.service.game === 'tft' && this.service.current === DivisionsService.getValueByRank('Master', 'tft')) {
        lpSelector.lps = (this.tftMToGmLps || {})[this.service.server];
      } else if (this.service.game === 'lol' && this.service.current === DivisionsService.getValueByRank('Master', 'lol')) {
        lpSelector.lps = (this.mToGmLps || {})[this.service.server];
      } else if ((this.service.service === 'divisions' && this.service.game === 'valorant' &&
        (this.service.current === DivisionsService.getValueByRank('Immortal I', 'valorant') ||
          this.service.current === DivisionsService.getValueByRank('Immortal II', 'valorant') ||
          this.service.current === DivisionsService.getValueByRank('Immortal III', 'valorant')))) {
        lpSelector.lps = (this.valorantMToGmLps || {})[this.service.server].filter(item => item.rank === this.service.current);
      }
    }

    lpSelector.selected
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(lp => {

        this.service = {
          ...this.service,
          promos: null,
          lp
        };
        this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-promos', '', 3650, '/');
        this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-lp', lp.toString(), 3650, '/');

        this.calculateServiceTime();
      });
  }

  public divisionName(state) {
    if (this.service.service !== 'normalgames' && this.service.service !== 'masteries' && this.service.service !== 'leveling' && this.service.service !== 'badges') {
      return this.divisionService.getDivisionNameByValue(this.service[state], this.service.game)
    } else if (this.service.game === 'cs2' && this.service.service === 'masteries') {
      return this.divisionService.getMasteryName(this.service[state], this.service.game);
    } else {
      return '';
    }
  }

  public showMapSelect() {
    let component = Cs2MapsSelectComponent;
    const mapSelector = this.modalService.open(
      'cs2-maps',
      component,
      false,
      {
        width: '1200px'
      },
      this.resolver
    ) as Cs2MapsSelectComponent;
    mapSelector.lang = this.lang;

    mapSelector.selected
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((map: any) => {
        this.service = {
          ...this.service,
          champion: map
        };

        this.cookie.set('gg-' + this.serviceParams.game + '-' + this.serviceParams.service + '-character', map, 3650, '/');
      });
  }

  public showRankSelect(state) {
    let component;
    if (this.service.game === 'cs2') {
      if (this.service.queue === 'premier' && state === 'current') {
        return;
      } else if (this.service.queue === 'premier') {
        component = Cs2RatingSelectComponent;
      } else if (this.service.queue === 'competitive') {
        component = Cs2RankSelectComponent;
      }
    } else if (this.service.game === 'valorant') {
      component = ValorantRankSelectComponent;
    } else if (this.service.game === 'tft') {
      component = TftRankSelectModalComponent;
    } else if (this.service.game === 'apex') {
      component = ApexRankSelectComponent;
    } else if (this.service.game === 'wild-rift') {
      component = WildRiftRankSelectComponent;
    } else if (this.service.game === 'overwatch') {
      component = OverwatchRankSelectModalComponent;
    } else {
      component = RankSelectModalComponent;
    }

    const serviceDefinition = this.getServiceDefinition();
    const rankSelector = this.modalService.open(
      'rankSelect',
      component,
      false,
      {
        width: '1340px'
      },
      this.resolver
    ) as RankSelectModalComponent;
    rankSelector.lang = this.lang;
    rankSelector.state = state;
    rankSelector.game = this.service.game;

    if (state === 'current') {
      if (this.service.type === 'solo') {
        rankSelector.min = serviceDefinition.soloCurrentMin;
        rankSelector.max = serviceDefinition.soloCurrentMax;
      }
      if (this.service.type === 'duo') {
        rankSelector.min = serviceDefinition.duoCurrentMin;
        rankSelector.max = serviceDefinition.duoCurrentMax;
      }
    }

    if (state === 'desired') {
      if (this.service.type === 'solo') {
        rankSelector.min = serviceDefinition.soloDesiredMin;
        rankSelector.max = serviceDefinition.soloDesiredMax;
      }
      if (this.service.type === 'duo') {
        rankSelector.min = serviceDefinition.duoDesiredMin;
        rankSelector.max = serviceDefinition.duoDesiredMax;
      }
    }

    rankSelector.selected
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((rank: any) => {
        let lp = state === 'current' ? 0 : this.service.lp;
        if (state === 'current' && this.serviceParams.game === 'valorant' &&
          (rank === DivisionsService.getValueByRank('Immortal I', 'valorant') ||
            rank === DivisionsService.getValueByRank('Immortal II', 'valorant') ||
            rank === DivisionsService.getValueByRank('Immortal III', 'valorant'))) {
          lp = this.findMinLp(rank, this.serviceParams.game);
        }
        if (state === 'current' && (this.serviceParams.game === 'lol' || this.serviceParams.game === 'tft') &&
          rank === DivisionsService.getValueByRank('Master', this.serviceParams.game)) {
          lp = this.findMinLp(this.service.current, this.serviceParams.game);
        }
        if (state === 'current' && this.serviceParams.game === 'wild-rift' && rank === DivisionsService.getValueByRank('Grandmaster', this.serviceParams.game)) {
          lp = 30;
        }

        this.service = {
          ...this.service,
          [state === 'current' ? 'current' : 'desired']: rank,
          lp
        };

        if (this.service.service === 'divisions' || this.service.service === 'doubleup' || this.service.service === 'masteries') {
          if (state === 'current' && this.service.current >= this.service.desired) {
            this.service = {
              ...this.service,
              desired: this.service.current + 1
            };
            const desiredCookie = this.service.current + 1;
            this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-desired', String(desiredCookie), 3650, '/');
          }

          if (state === 'desired' && this.service.current >= this.service.desired) {
            this.service = {
              ...this.service,
              current: this.service.desired - 1,
              lp: this.findMinLp(this.service.desired - 1, this.game)
            };
            const currentCookie = this.service.desired - 1;
            this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-lp', String(lp), 3650, '/');
            this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-current', String(currentCookie), 3650, '/');
          }
        }

        this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-' + state, rank, 3650, '/');
        if (this.game !== 'cs2') {
          this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-lp', lp.toString(), 3650, '/');
          this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-promos', '', 3650, '/');
        }

        /*this.service = {
          ...this.service,
          lp: 0,
          promos: ''
        };*/

        this.calculateServiceTime();
      });
  }

  public onMasterySelect(state) {
    const masterySelector = this.modalService.open(
      'rankSelect',
      MasterySelectModalComponent,
      false,
      {
        width: '1200px'
      },
      this.resolver
    ) as MasterySelectModalComponent;

    if (state === 'current') {
      masterySelector.min = 0;
      masterySelector.max = 9;
    }

    if (state === 'desired') {
      masterySelector.min = 1;
      masterySelector.max = 10;
    }

    masterySelector.selected
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((mastery: any) => {
        this.service = {
          ...this.service,
          [state === 'current' ? 'current' : 'desired']: mastery
        };

        this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-' + state, mastery, 3650, '/');
        this.calculateServiceTime();
      });
  }

  public onBadgeSelect() {

    const badgeSelector = this.modalService.open(
      'badgeSelect',
      ApexBadgeSelectComponent,
      false,
      {
        width: '1200px'
      },
      this.resolver
    ) as ApexBadgeSelectComponent;
    badgeSelector.lang = this.lang;

    badgeSelector.selected
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((badge: any) => {
        this.service = {
          ...this.service,
          badge: badge,
          desired: badge
        };

        this.cookie.set('gg-' + this.game + '-' + this.serviceParams.service + '-desired', badge, 3650, '/');
        this.cookie.set('gg-' + this.game + '-' + this.serviceParams.service + '-badge', badge, 3650, '/');
        this.calculateServiceTime();
      });
  }

  onCharacterSelect(game) {

    var component;
    let width = '1200px';

    if (game === 'lol') {
      component = LolCharacterSelectComponent;
    } else if (game === 'apex') {
      component = GameCharacterSelectComponent;
      width = '600px';
    }

    const characterSelector = this.modalService.open(
      'characterSelect',
      component,
      false,
      {width: width},
      this.resolver
    ) as typeof component;
    characterSelector.lang = this.lang;

    if (game === 'apex') {
      characterSelector.game = game;
    }

    characterSelector.singleSelect = true;
    characterSelector.selected.pipe(takeUntil(this.componentDestroyed)).subscribe((champion: string) => {
      this.service = {
        ...this.service,
        champion
      };
      this.cookie.set('gg-' + this.serviceParams.game + '-' + this.serviceParams.service + '-character', champion, 3650, '/');
    });

  }

  public showDivisionSelect() {
    let component;

    if (this.service.game === 'valorant') {
      component = ValorantDivisionSelectComponent;
    } else if (this.service.game === 'apex') {
      component = ApexDivisionSelectComponent;
    } else if (this.service.game === 'wild-rift') {
      component = WildRiftDivisionSelectComponent;
    } else if (this.service.game === 'lol') {
      component = DivisionSelectModalComponent;
    } else if (this.service.game === 'tft') {
      component = TftDivisionSelectModalComponent;
    }

    const divisionSelector = (
      this.modalService.open(
        'divisionSelect',
        component,
        false,
        {width: '1300px'},
        this.resolver
      )
    ) as DivisionSelectModalComponent;

    divisionSelector.lang = this.lang;


    if (this.service.type === 'duo') {
      divisionSelector.allowMaster = true;
      divisionSelector.allowGrandmaster = true;
    }

    divisionSelector.selected
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((rank: any) => {
        this.service = {
          ...this.service,
          current: rank
        };

        this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-current', rank, 3650, '/');
        this.calculateServiceTime();
      });
  }

  onAmountChange(state, val) {
    // used to select number amounts in different games, but on cs2 it can be rating as well
    if (this.service.game === 'cs2' && (this.serviceParams.service === 'divisions' || this.serviceParams.service === 'netwins')) {

      let currentRank = this.service.current;
      let lp = 0;
      let desiredRank = this.service.desired;

      // divisions only come here through current, never desired
      if (state === 'current') {
        currentRank = Math.floor(val / 1000);
      }

      if (this.serviceParams.service === 'divisions') {
        lp = val % 1000;
        if (currentRank >= desiredRank) {
          desiredRank = currentRank + 1;
        }
      }
      if (this.serviceParams.service === 'netwins' && state === 'desired') {
        desiredRank = val;
      }
      if (this.serviceParams.service === 'netwins' && state === 'current') {
        lp = val % 1000;
      }
      this.service = {
        ...this.service,
        current: currentRank,
        desired: desiredRank,
        lp: lp
      };
      this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-lp', String(lp), 3650, '/');
      this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-current', String(currentRank), 3650, '/');
      this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-desired', String(desiredRank), 3650, '/');
    } else {
      let value = parseFloat(val);
      if (state === 'current') {
        value = value < this.serviceParams.min ? this.serviceParams.min : value;
        value = value > this.serviceParams.max ? this.serviceParams.max : value;
      }
      this.service = {
        ...this.service,
        [state]: value
      };

      this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-' + state, value.toString(), 3650, '/');
    }

    this.calculateServiceTime();
  }

  private calculateServiceTime() {
    this.delay = AverageCompletionService.getEstimateTimes(this.service);
  }

  public displayRankName(): string {
    if (this.service.service !== 'normalgames' && this.service.service !== 'masteries' && this.service.service !== 'leveling') {
      if (this.service.service === 'placements') {
        if (this.game === 'tft' &&
          (this.service.current === this.divisionService.getValueByRank('Diamond IV', this.service.game) ||
            this.service.current === this.divisionService.getValueByRank('Diamond III', this.service.game) ||
            this.service.current === this.divisionService.getValueByRank('Diamond II', this.service.game) ||
            this.service.current === this.divisionService.getValueByRank('Diamond I', this.service.game))) {
          return this.divisionService.getRankNameByValue(this.service.current, this.service.game);
        } else if (this.game === 'lol' &&
          (this.service.current === this.divisionService.getValueByRank('Diamond IV', this.service.game) ||
            this.service.current === this.divisionService.getValueByRank('Diamond III', this.service.game) ||
            this.service.current === this.divisionService.getValueByRank('Diamond II', this.service.game) ||
            this.service.current === this.divisionService.getValueByRank('Diamond I', this.service.game))) {
          return this.divisionService.getRankNameByValue(this.service.current, this.service.game);
        } else {
          return 'DIVISION';
        }
      } else {
        return this.divisionService.getRankNameByValue(this.service.current, this.service.game);
      }
    } else {
      return '';
    }
  }

  private calculateEstimatedTime(divisions: number, totalTime: number): string {
    let additionalTime = 1;

    if (divisions <= 2) {
      additionalTime = 1;
    } else if (divisions < 5) {
      additionalTime = 1.3;
    } else {
      additionalTime = 1.4;
    }

    totalTime = Number(totalTime * additionalTime);

    if (totalTime <= 24) {
      return totalTime + ' hours';
    } else {
      const totalDays = Number(totalTime / 24);

      if (totalDays > 1) {
        return totalDays.toFixed(0) + ' days';
      } else {
        return totalDays.toFixed(0) + ' day';
      }
    }
  }

  private findMinLp(currentRank, game) {

    if (game === 'cs2') {
      if (this.service.lp != 0) {
        return this.service.lp;
      }
      return 0;
    } else if (game === 'valorant') {

      if (this.valorantMToGmLps !== undefined) {
        const first = this.valorantMToGmLps[this.service.server].find(item => item.rank === currentRank);

        if (first) {
          return first.minLp;
        }
      }

      return 0;
    } else if (game === 'lol') {

      if (this.mToGmLps !== undefined) {
        const first = this.mToGmLps[this.service.server].find(item => item.rank === currentRank);

        if (first) {
          return first.minLp;
        }
      }

      return 0;
    } else if (game === 'tft') {

      if (this.tftMToGmLps !== undefined) {
        const first = this.tftMToGmLps[this.service.server].find(item => item.rank === currentRank);

        if (first) {
          return first.minLp;
        }
      }

      return 0;
    }
    return 0;
  }

  private findMinValorantLp(currentRank) {

    if (this.valorantMToGmLps !== undefined) {
      const first = this.valorantMToGmLps[this.service.server].find(item => item.rank === currentRank);

      if (first) {
        return first.minLp;
      }
    }

    return 0;
  }

  private fixValues() {
    const unrankedValue = this.getUnrankedValue();
    const serviceDefinition = this.getServiceDefinition();

    const currentMin = this.service.type === 'solo' ? serviceDefinition.soloCurrentMin : serviceDefinition.duoCurrentMin;
    const currentMax = this.service.type === 'solo' ? serviceDefinition.soloCurrentMax : serviceDefinition.duoCurrentMax;
    const desiredMin = this.service.type === 'solo' ? serviceDefinition.soloDesiredMin : serviceDefinition.duoDesiredMin;
    const desiredMax = this.service.type === 'solo' ? serviceDefinition.soloDesiredMax : serviceDefinition.duoDesiredMax;

    let current = this.service.current;
    let desired = this.service.desired;

    if (this.service.service !== 'placements' || (this.service.service === 'placements' && current !== unrankedValue)) {
      if (current < currentMin) {
        current = currentMin;
        this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-current', String(current), 3650, '/');
      }
      if (current > currentMax) {
        current = currentMax;
        this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-current', String(current), 3650, '/');
      }
    }
    if (desired < desiredMin) {
      desired = desiredMin;
      this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-desired', String(desired), 3650, '/');
    }
    if (desired > desiredMax) {
      desired = desiredMax;
      this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-desired', String(desired), 3650, '/');
    }

    let cookieLp = parseInt(this.cookie.get('gg-' + this.prefix + this.serviceParams.service + '-lp'));

    if (((this.service.game === 'lol' && this.service.service === 'divisions' &&
          (DivisionsService.getValueByRank('Master', 'lol') > current))
        ||
        (this.service.game === 'tft' && (this.service.service === 'divisions' || this.service.service === 'doubleup') &&
          (DivisionsService.getValueByRank('Master', 'tft') > current))) &&
      ![0, 21, 41, 61, 81].includes(cookieLp)) {
      this.cookie.set('gg-' + this.serviceParams.game + '-' + this.serviceParams.service + '-lp', '0', 3650, '/');
      cookieLp = 0;
    }

    this.service = {
      ...this.service,
      current,
      desired,
      lp: cookieLp
    };
  }

  private getDefaultQueue(): string {
    let queue = !this.isBrowser ? 'soloq' : this.cookie.get('gg-' + this.prefix + this.serviceParams.service + '-queue') || 'soloq';

    if (this.serviceParams.queue) {
      return this.serviceParams.queue;
    }

    if (this.serviceParams.service === 'masteries' || this.serviceParams.service === 'leveling') {
      queue = 'draftq';
    }

    if (this.serviceParams.service === 'normalgames') {
      queue = 'draftq';
    }

    if (this.serviceParams.game === 'valorant' || this.serviceParams.game === 'wild-rift') {
      queue = 'soloq';
    }

    return queue;
  }

  private getDefaultPlatform(): string {
    return !this.isBrowser ? 'pc' : this.cookie.get('gg-' + this.game + '-platform') || 'pc';
  }

  private getDefaultServer(): string {
    let server = !this.isBrowser ? 'euw' : this.cookie.get('gg-' + this.game + '-server');
    if (this.serviceParams.game === 'wild-rift' && (server === 'euw' || server === 'eune')) {
      server = 'eu';
    }
    if (this.serviceParams.game === 'valorant' && (server === 'euw' || server === 'eune')) {
      server = 'eu';
    }
    if (this.serviceParams.game === 'marvel' && (server === 'euw' || server === 'eune')) {
      server = 'eu';
    }
    if (this.serviceParams.game !== 'valorant' && this.serviceParams.game !== 'wild-rift' && this.serviceParams.game !== 'marvel' && server === 'eu') {
      server = 'euw';
    }

    return server;
  }

  private getDefaultCurrent(): number {
    if (!this.isBrowser) {
            return this.serviceParams.start;
    } else {
      if (this.cookie.check('gg-' + this.prefix + this.serviceParams.service + '-current')) {
        return parseFloat(this.cookie.get('gg-' + this.prefix + this.serviceParams.service + '-current'));
      } else {
        this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-current', String(this.serviceParams.start), 3650, '/');
        return this.serviceParams.start;
      }
    }
  }

  private getDefaultDesired(): number {
    if (!this.isBrowser) {
      return this.serviceParams.desired;
    } else {
      if (this.cookie.check('gg-' + this.prefix + this.serviceParams.service + '-desired')) {
        return parseFloat(this.cookie.get('gg-' + this.prefix + this.serviceParams.service + '-desired'));
      } else {
        this.cookie.set('gg-' + this.prefix + this.serviceParams.service + '-desired', String(this.serviceParams.desired), 3650, '/');
        return this.serviceParams.desired;
      }
    }
  }

  private getDefaultLp(): number {
    if (!this.isBrowser) {
      return 0;
    }
    if (this.cookie.get('gg-' + this.serviceParams.game + '-' + this.serviceParams.service + '-lp')) {
      return parseInt(this.cookie.get('gg-' + this.serviceParams.game + '-' + this.serviceParams.service + '-lp'));
    } else {
      this.cookie.set('gg-' + this.serviceParams.game + '-' + this.serviceParams.service + '-lp', '0', 3650, '/');
      return 0;
    }
  }

  private async fetchPrices() {
    const prices = await this.priceService.fetchPrices().toPromise();
    this.mToGmLps = prices.mToGmLps;
    this.tftMToGmLps = prices.tftMToGmLps;
    this.valorantMToGmLps = prices.valorantMToGmLps;
  }

  private setTimers(){
    if(this.isBrowser && this.campaignTimerByGame[this.game]) {
      this.updateCountdown();
      this.seasonEndCountdown = setInterval(() => this.updateCountdown(), 1000);
    }
  }

  private setService() {
    this.game = this.serviceParams.game;

    if(this.isBrowser) {
      this.cookie.set('gg-game', this.game, 3650, '/');
    }

    this.prefix = this.game + '-';

    const champion = !this.isBrowser ? '' : this.cookie.get('gg-' + this.game + '-' + this.serviceParams.service + '-character') || this.serviceParams.champion || this.serviceParams.map;
    const badge = !this.isBrowser ? 0 : parseInt(this.cookie.get('gg-' + this.game + '-' + this.serviceParams.service + '-badge')) || this.serviceParams.badge;
    //const map = this.cookie.get('gg-' + this.game + '-map') || this.serviceParams.map;

    let isDuoAvailable;
    if (this.game === 'tft' && this.serviceParams.queue === 'doubleup') {
      isDuoAvailable = true;
    } else {
      isDuoAvailable = services[this.game].find(serviceDefinition => serviceDefinition.service === this.serviceParams.service).isDuoAvailable;
    }
    let isSoloAvailable = services[this.game].find(serviceDefinition => serviceDefinition.service === this.serviceParams.service).isSoloAvailable;

    let cookieType = this.cookie.get('gg-type');

    let type = '';
    if (cookieType === 'solo' && !isSoloAvailable) {
      type = 'duo';
    } else if (cookieType === 'duo' && !isDuoAvailable) {
      type = 'solo';
    } else {
      type = cookieType || this.serviceParams.type;
    }

    this.service = {
      game: this.game,
      service: this.serviceParams.service,
      type: type,
      queue: this.getDefaultQueue(),
      platform: this.getDefaultPlatform(),
      server: this.getDefaultServer(),
      current: this.getDefaultCurrent(),
      desired: this.getDefaultDesired(),
      lp: this.getDefaultLp(),
      isExpress: false,
      champion,
      badge
    };


    if (this.serviceParams.game === 'valorant' &&
      (
        this.service.current === DivisionsService.getValueByRank('Immortal II', this.service.game) ||
        this.service.current === DivisionsService.getValueByRank('Immortal III', this.service.game)
      )
    ) {
      this.service.lp = this.findMinLp(this.service.current, this.serviceParams.game);
    }

    if ((this.serviceParams.game === 'lol' || this.serviceParams.game === 'tft') &&
      this.service.current === DivisionsService.getValueByRank('Master', this.service.game)

    ) {
      this.service.lp = this.findMinLp(this.service.current, this.serviceParams.game);
    }
  }

  private getServiceDefinition() {
    let serviceDefinitions = services[this.service.game];

    return serviceDefinitions.find(s => s.service === this.service.service);
  }

  private getUnrankedValue() {
    return DivisionsService.getValueByRank('Unranked', this.service.game);
  }

  ngOnDestroy() {
    this.componentDestroyed.next(1);
    this.componentDestroyed.unsubscribe();
    clearInterval(this.seasonEndCountdown);

    if (this.scrollingInstance) {
      this.scrollingInstance.destroy();
    }
  }
}